export default "__VITE_ASSET__DnIljcfs__"